function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.6,
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#E7F2F5"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7212 19.24L17.0892 14.952C17.4412 14.6107 17.7185 14.2693 17.9212 13.928C18.1345 13.576 18.2412 13.176 18.2412 12.728C18.2412 12.1947 18.0652 11.7733 17.7132 11.464C17.3719 11.144 16.9452 10.984 16.4332 10.984C15.8892 10.984 15.4519 11.1707 15.1212 11.544C14.7905 11.9067 14.5879 12.3653 14.5132 12.92L12.6412 12.632C12.6945 12.1627 12.8279 11.7307 13.0412 11.336C13.2545 10.9413 13.5265 10.6 13.8572 10.312C14.1879 10.024 14.5719 9.8 15.0092 9.64C15.4572 9.46933 15.9425 9.384 16.4652 9.384C16.9559 9.384 17.4252 9.45333 17.8732 9.592C18.3319 9.73067 18.7372 9.944 19.0892 10.232C19.4412 10.5093 19.7185 10.856 19.9212 11.272C20.1345 11.6773 20.2412 12.152 20.2412 12.696C20.2412 13.0587 20.1932 13.4 20.0972 13.72C20.0012 14.0293 19.8679 14.3227 19.6972 14.6C19.5372 14.8773 19.3452 15.144 19.1212 15.4C18.9079 15.6453 18.6732 15.8853 18.4172 16.12L15.1532 19.24H20.2572V21H12.7212V19.24Z",
  fill: "#117A9B"
});

const SvgTwo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/two.b08bd759.svg";
export { ForwardRef as ReactComponent };